export default __webpack_public_path__ + "static/media/guide_button.d9ccdbf2.svg";